import React from 'react'
import {Icon} from '@chakra-ui/react'

const WebsiteIcon = (props) => {
    return (
        <Icon viewBox="0 0 40 40" {...props}>
            <g clipPath="url(#clip0_1956_1355)">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6.67546 6.67546C10.2093 3.14157 15.0023 1.15625 20 1.15625C24.9977 1.15625 29.7907 3.14157 33.3245 6.67546C36.8584 10.2093 38.8438 15.0023 38.8438 20C38.8438 24.9977 36.8584 29.7907 33.3245 33.3245C29.7907 36.8584 24.9977 38.8438 20 38.8438C15.0023 38.8438 10.2093 36.8584 6.67546 33.3245C3.14157 29.7907 1.15625 24.9977 1.15625 20C1.15625 15.0023 3.14157 10.2093 6.67546 6.67546ZM20 4.15625C15.798 4.15625 11.7681 5.8255 8.79678 8.79678C5.8255 11.7681 4.15625 15.798 4.15625 20C4.15625 24.202 5.8255 28.2319 8.79678 31.2032C11.7681 34.1745 15.798 35.8438 20 35.8438C24.202 35.8438 28.2319 34.1745 31.2032 31.2032C34.1745 28.2319 35.8438 24.202 35.8438 20C35.8438 15.798 34.1745 11.7681 31.2032 8.79678C28.2319 5.8255 24.202 4.15625 20 4.15625Z"
                    fill="black"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M17.6159 1.83021C18.285 2.31876 18.4313 3.25717 17.9427 3.92621C15.7954 6.86689 14.1768 13.0108 14.1768 20.077C14.1768 27.1289 15.79 33.1341 17.9523 36.164C18.4335 36.8383 18.277 37.7751 17.6027 38.2563C16.9283 38.7376 15.9916 38.581 15.5104 37.9067C12.8318 34.1533 11.1768 27.4243 11.1768 20.077C11.1768 12.744 12.8265 5.84549 15.5199 2.15701C16.0085 1.48797 16.9469 1.34166 17.6159 1.83021Z"
                    fill="black"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M22.3841 1.83021C23.0531 1.34166 23.9915 1.48797 24.4801 2.15701C27.1735 5.84549 28.8233 12.744 28.8233 20.077C28.8233 27.4243 27.1682 34.1533 24.4896 37.9067C24.0084 38.581 23.0717 38.7376 22.3973 38.2563C21.723 37.7751 21.5665 36.8383 22.0477 36.164C24.21 33.1341 25.8233 27.1289 25.8233 20.077C25.8233 13.0108 24.2047 6.86689 22.0573 3.92621C21.5687 3.25717 21.715 2.31876 22.3841 1.83021Z"
                    fill="black"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M2.5 26C2.5 25.1716 3.17157 24.5 4 24.5H36C36.8284 24.5 37.5 25.1716 37.5 26C37.5 26.8284 36.8284 27.5 36 27.5H4C3.17157 27.5 2.5 26.8284 2.5 26Z"
                    fill="black"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M2.5 14C2.5 13.1716 3.17157 12.5 4 12.5H36C36.8284 12.5 37.5 13.1716 37.5 14C37.5 14.8284 36.8284 15.5 36 15.5H4C3.17157 15.5 2.5 14.8284 2.5 14Z"
                    fill="black"
                />
            </g>
            <defs>
                <clipPath id="clip0_1956_1355">
                    <rect
                        width="40"
                        height="40"
                        fill="white"
                        transform="translate(0 0.000366211)"
                    />
                </clipPath>
            </defs>
        </Icon>
    )
}

export default WebsiteIcon
